import service from '@api/config'

// 分页查询系统消息列表
export const sysMsgList = (data) => {
  return service.request({
    url: `/message/sysMsgList`,
    method: 'post',
    data: data
  })
}

// 消息设置已读
export const sysMsgRead = (data) => {
  return service.request({
    url: `/message/sysMsgRead`,
    method: 'post',
    data: data
  })
}

// 根据消息id查询系统消息内容
export const sysMsgInfo = (data) => {
  return service.request({
    url: `/message/sysMsgInfo`,
    method: 'post',
    data: data
  })
}

// 中期评价详情
export const midAssessProjectInfo = (data) => {
  return service.request({
    url: `/project/midAssessProjectInfo`,
    method: 'post',
    data: data
  })
}
// 提交中期评价
export const midAssess = (data) => {
  return service.request({
    url: `/project/midAssess`,
    method: 'post',
    data: data
  })
}

// 完工评价详情
export const unitAssess = (data) => {
  return service.request({
    url: `/message/unitAssess`,
    method: 'post',
    data: data
  })
}

// 完工评价
export const finishAssessProjectInfo = (data) => {
  return service.request({
    url: `/project/finishAssessProjectInfo`,
    method: 'post',
    data: data
  })
}

// 已评价信息
export const assessInfo = (data) => {
  return service.request({
    url: `/project/assessInfo`,
    method: 'post',
    data: data
  })
}

// 邀请加入—查看个人资料
export const getUserDetail = (data) => {
  return service.request({
    url: `/user/getUserDetail`,
    method: 'post',
    data: data
  })
}

// 申请加入- 查看组织材料
export const getCompanyDetail = (data) => {
  return service.request({
    url: `/user/getCompanyDetail`,
    method: 'post',
    data: data
  })
}

// 个人拒绝组织邀请
export const refuseInvite = (data) => {
  return service.request({
    url: `/user/refuseInvite`,
    method: 'post',
    data: data
  })
}

// 个人同意组织邀请
export const agreeInvite = (data) => {
  return service.request({
    url: `/user/agreeInvite`,
    method: 'post',
    data: data
  })
}

// 组织同意个人加入
export const agreeApply = (data) => {
  return service.request({
    url: `/user/agreeApply`,
    method: 'post',
    data: data
  })
}

// 组织拒绝个人加入
export const refuseApply = (data) => {
  return service.request({
    url: `/user/refuseApply`,
    method: 'post',
    data: data
  })
}
// 获取是否有新消息
export const getNewMsgCount = (data) => {
  return service.request({
    url: `/message/getNewMsgCount`,
    method: 'post',
    data: data
  })
}

// 组织模块-获取基本信息
export const getUserInfo = (data) => {
  return service.request({
    url: `/user/getDetail`,
    method: 'post',
    data: data
  })
}
